// import * as environment from '../assets/config.json';
export class FranchiseAppGlobal {
  //*****Start private Domains */
  private static adminArea: string = "Admin/";
  private static reportsArea: string = "Reports/";

  // private static franchiseDomain: string = environment.baseUrl + environment.baseUrlVersion;
  private static lookupCategoriesService: string = "lookupCategory/";
  private static lookupService: string = "lookup/";
  private static countryService: string = "country/";
  private static districtService: string = "district/";
  private static requestService: string = "request/";
  private static eFIleService: string = "eFile/";
  private static attachmentService: string = "attachment/";
  private static deleteAttachmentService: string = "attachment";
  private static crService: string = "cr/";
  private static franchiseService: string = "franchise/";
  private static paymentService: string = "payment/";
  private static sharedService: string = "shared/";
  private static trademarkService: string = "tradeMark/";
  private static accountService: string = "Account/";
  private static userManagementService: string = "UserManagement/";
  private static franchiseAdminService: string = "FranchiseAdmin/";
  private static donorRequestAdminService: string = "RequestAdmin/";
  private static FranchiseCertificateService: string = "FranchiseCertificate/";
  private static ReasonService: string = "Reason/";
  //*****End private Domains */

  //#region Request Sync API Urls.

  public static getAllCategoriesUrl: string =
    FranchiseAppGlobal.lookupCategoriesService + "lookupCategories/";
  public static getAllLookupsByCategoryUrl: string =
    FranchiseAppGlobal.lookupService + "lookups/";
  public static getAllLookupsByParentUrl: string =
    FranchiseAppGlobal.lookupService + "childLookups/";
  public static getAllLookupsByParentsUrl: string =
    FranchiseAppGlobal.lookupService + "getchildLookupsByParents/";
  public static getLimitidLookupsByParentsUrl: string =
    FranchiseAppGlobal.lookupService + "getLimitedChildLookupsByParents/";
  public static getAllLookupsByCountryUrl: string =
    FranchiseAppGlobal.countryService + "countries";
  public static getAllLookupsByDistrictUrl: string =
    FranchiseAppGlobal.districtService + "districts?cities=";

  public static getAllCancelReason: string =
    FranchiseAppGlobal.ReasonService + "cancellationReasonSelect";
  //#endregion

  //#region Request Service
  public static createBasicRequest: string =
    FranchiseAppGlobal.requestService + "basicRequest";
  public static getDonorActiveCRs: string =
    FranchiseAppGlobal.requestService + "donorActiveCRs/";
  public static getDonorInfo: string =
    FranchiseAppGlobal.requestService + "donorInfo/";
  public static getDonorCrInfo: string =
    FranchiseAppGlobal.requestService + "cRInfo/";
  public static saveStep1: string =
    FranchiseAppGlobal.requestService + "saveStep1/";
  public static saveStep2: string =
    FranchiseAppGlobal.requestService + "saveStep2/";
  public static getGrantedCrInfo: string =
    FranchiseAppGlobal.requestService + "getGrantedCRInfo/";
  public static saveStep3: string =
    FranchiseAppGlobal.requestService + "saveStep3/";
  public static getSummary: string =
    FranchiseAppGlobal.requestService + "summaryById/";
  public static saveStep4: string =
    FranchiseAppGlobal.requestService + "saveStep4/";
  public static saveStep5CreditCard: string =
    FranchiseAppGlobal.requestService + "saveStep5CreditCard/";
  public static saveStep5ThiqahSadad: string =
    FranchiseAppGlobal.requestService + "saveStep5ThiqahSadad/";
  public static saveStep5Aamaly: string =
    FranchiseAppGlobal.requestService + "saveStep5Aamaly/";
  public static step5CreditCardConfirm: string =
    FranchiseAppGlobal.requestService + "step5CreditCardConfirm";
  public static step5AamalyConfirm: string =
    FranchiseAppGlobal.requestService + "Step5AamalyConfirm";
  public static getMyDonorRequests: string =
    FranchiseAppGlobal.requestService + "getMyDonorRequests/";

  public static initiateBasicUpdateRequest: string =
    FranchiseAppGlobal.requestService + "initiateBasicUpdateRequest";
  public static getUpdateRequestDonorInfoUrl: string =
    FranchiseAppGlobal.requestService + "updateRequestDonorInfo/";
  public static getUpdatedDonorCrInfo: string =
    FranchiseAppGlobal.requestService + "getUpdatedDonorCRInfo/";
  public static getUpdatedGrantedCrInfo: string =
    FranchiseAppGlobal.requestService + "getUpdatedGrantedCRInfo/";
  public static getUpdateRequestUrl: string =
    FranchiseAppGlobal.requestService + "updateRequestFranchiseInfo/";
  public static saveUpdateRequestInternalDonorInfoStep: string =
    FranchiseAppGlobal.requestService + "SaveUpdatedInternalDonorInfo/";
  public static saveUpdateRequestExternalDonorInfoStep: string =
    FranchiseAppGlobal.requestService + "SaveUpdatedExternalDonorInfo/";
  public static saveUpdateRequestFranchiseInfoStep: string =
    FranchiseAppGlobal.requestService + "SaveUpdateRequestFranchiseInfoStep/";
  public static updateContractChange: string =
    FranchiseAppGlobal.requestService + "updateContractChange/";
  public static getUpdateRequestGrantedInfo: string =
    FranchiseAppGlobal.requestService + "UpdateRequestGrantedInfo/";
  public static saveGrantedInfoStep: string =
    FranchiseAppGlobal.requestService + "saveUpdatedGrantedInfoStep/";
  public static getUpdateRequestSummaryByRequestId: string =
    FranchiseAppGlobal.requestService + "updateRequestSummaryByRequestId/";
  public static saveUpdateRequestSummaryStep: string =
    FranchiseAppGlobal.requestService + "saveUpdateRequestSummaryStep/";

  public static saveUpdateRequestCreditCardStep: string =
    FranchiseAppGlobal.requestService + "saveUpdateRequestCreditCardStep/";
  public static saveUpdateRequestThiqahSadadStep: string =
    FranchiseAppGlobal.requestService + "saveUpdateRequestThiqahSadadStep/";
  public static saveUpdateRequestAamalyStep: string =
    FranchiseAppGlobal.requestService + "SaveUpdateStep5Aamaly/";
  public static saveUpdateRequestCreditCardConfirmStep: string =
    FranchiseAppGlobal.requestService +
    "saveUpdateRequestCreditCardConfirmStep";

  public static cancelNotPaidRequest: string =
    FranchiseAppGlobal.requestService + "cancelNotPaidRequest";
  public static viewPayment: string =
    FranchiseAppGlobal.requestService + "ViewPayment";
  //#endregion

  //#endregion

  //#region Attachments
  public static displayUploadedFileUrl: string =
    FranchiseAppGlobal.attachmentService + "Download/";

  public static displayAdminUploadedFileUrl: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.attachmentService +
    "Download/";

  public static fileAttachmentGet =
    FranchiseAppGlobal.attachmentService + "attachment";

  public static fileAdminAttachmentGet: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.attachmentService +
    "attachment";

  public static fileUploadUrl = FranchiseAppGlobal.attachmentService + "Upload";

  public static fileAdminUploadUrl: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.attachmentService +
    "Upload";

  public static deleteFileUrl =
    FranchiseAppGlobal.deleteAttachmentService + "/deleteByMetaData";

  public static deleteAdminFileUrl: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.attachmentService +
    "deleteByMetaData";

  public static previewFileUrl =
    FranchiseAppGlobal.attachmentService + "preview/";

  public static previewAdminFileUrl: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.attachmentService +
    "preview/";
  //#endregion Attachments

  //#region Shared
  public static downloadUserManual: string =
    FranchiseAppGlobal.sharedService + "downloadUserManual/";

  public static getPersonInfo: string =
    FranchiseAppGlobal.eFIleService + "personInfo/";
  //#endregion Attachments

  //#region Cr
  public static getCrInfoByPartyIdUrl: string =
    FranchiseAppGlobal.crService + "CrListByPartyID";
  //#endregion Cr

  //#region Franchise Service
  public static getMyFranchises: string =
    FranchiseAppGlobal.franchiseService + "getMyFranchises/";
  public static getFranchisebyNo: string =
    FranchiseAppGlobal.franchiseService + "franchiseByNo/";
  public static cancelFranchise: string =
    FranchiseAppGlobal.franchiseService + "cancelFranchise";
  //#endregion Franchise Service

  //#region Payment Service
  public static getCreateRequestCost: string =
    FranchiseAppGlobal.paymentService + "getCreateRequestCost/";
  public static getCreateRequestCostAamaly: string =
    FranchiseAppGlobal.paymentService + "getCreateRequestCostAamaly/";
  public static getUpdateRequestCost: string =
    FranchiseAppGlobal.paymentService + "getUpdateRequestCost/";
  public static getUpdateRequestCostAamaly: string =
    FranchiseAppGlobal.paymentService + "getUpdateRequestCostAamaly/";
  //#endregion Payment Service

  //#region Request Sync API Urls.
  public static getTradeMarkByCRNumber: string =
    FranchiseAppGlobal.trademarkService + "tradeMarkByCRNumber?CRNumber=";
  public static getTradeMarkInfoByTMId: string =
    FranchiseAppGlobal.trademarkService + "TradeMarkInfo/";
  //#endregion

  //#region Account Sync API Urls.
  public static adminAuthenticate: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "Authenticate";
  public static adminLogin: string =
    FranchiseAppGlobal.adminArea + FranchiseAppGlobal.accountService + "Login";
  public static adminGetProfile: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "GetProfile";
  public static getCaptcha: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "GetCaptchaImage";
  public static adminLogout: string =
    FranchiseAppGlobal.adminArea + FranchiseAppGlobal.accountService + "Logout";

  public static adminGetPermissions: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "GetPermissions";

  public static emailActivation: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "EmailActivation?Id=";

  public static forgotPassword: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "ForgotPassword";

  public static getUserEmail: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "GetUserEmail?id=";

  public static resetPassword: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.accountService +
    "ResetPassword";
  //#endregion

  //#region User management API Urls.
  public static getUserTypesDDL: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "GetUserTypesDDL";

  public static getPermissionsDDL: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "GetPermissionsDDL";

  public static getAll: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "GetAll";

  public static getByIdForUpdate: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "GetByIdForUpdate?Id=";

  public static create: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "Create";

  public static update: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "Update";

  public static delete: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "Delete?Id=";

  public static activate: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "Activate?Id=";

  public static dectivate: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "Dectivate?Id=";

  public static exportExcel: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "ExportExcel";

  public static exportPdf: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.userManagementService +
    "ExportPdf";
  //#endregion

  //#region Reports
  public static getFranchiseAdminCertificate: string =
    FranchiseAppGlobal.reportsArea +
    FranchiseAppGlobal.FranchiseCertificateService +
    "downloadCertificateForAdmin";

  public static getFranchiseCertificate: string =
    FranchiseAppGlobal.reportsArea +
    FranchiseAppGlobal.FranchiseCertificateService +
    "downloadCertificate";
  //#endregion

  //#region lookupsAdmin
  public static getAllLookupsAdminByCategoryUrl: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.lookupService +
    "lookups/";
  public static getAdminLimitidLookupsByParentsUrl: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.lookupService +
    "getLimitedChildLookupsByParents/";
  //#endregion
  //#region Franchise Admin Service
  public static getFranchisesAdmin: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "GetAllAdminFranchises/";
  public static getFranchiseDetails: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "GetAdminFranchiseByNo/";
  public static exportFranchisesAdminAsExcel: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "ExportAllAdminFranchisesAsExcel/";
  public static exportFranchisesAdminAsPdf: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "ExportAllAdminFranchisesAsPdf/";

  public static getNextObjectId: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "GetNextObjectId/";

  public static addSuspendedFranchiseSuspension: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "AddSuspendedFranchise/";

  public static addViolatedFranchiseSuspension: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "AddViolatedFranchise/";

  public static cancelFranchiseByAdmin: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "CancelFranchiseByAdmin/";

  public static removeVoilatedFranchise: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "RemoveViolatedFranchise/";

  public static removeSuspensionFranchise: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.franchiseAdminService +
    "RemoveSuspendedFranchise/";
    
  //#region Donor Request Admin Service
  public static getDonorRequestAdmin: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.donorRequestAdminService +
    "GetMyDonorRequests/";
  public static donorRequestexportExcel: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.donorRequestAdminService +
    "ExportExcel";

  public static donorRequestexportPdf: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.donorRequestAdminService +
    "ExportPdf";
  //end

  // reason
  public static getAllReason: string =
    FranchiseAppGlobal.adminArea + FranchiseAppGlobal.ReasonService + "GetAll";

  public static getReasonById: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.ReasonService +
    "GetById/";

  public static createReason: string =
    FranchiseAppGlobal.adminArea + FranchiseAppGlobal.ReasonService + "create";

  public static updateReason: string =
    FranchiseAppGlobal.adminArea + FranchiseAppGlobal.ReasonService + "update";

  public static deActivateReason: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.ReasonService +
    "DeActivate/";

  public static getReasonSelect: string =
    FranchiseAppGlobal.adminArea +
    FranchiseAppGlobal.ReasonService +
    "GetReasonSelect/";
  //#endregion Franchise Service
}

export enum LookupCategories {
  Regions = 101,
  Cities = 102,
  AttachmentTypes = 7,
  CancelReasons = 11,
}

export enum AttachmentTypes {
  CrCopy = 60,
  OwnershipProof = 61,
  DislosureDocumnet = 62,
  Contracts = 63,
  Finance = 64,
  Passport = 65,
  Other = 66,
  Trademark = 67,
  CancelReason = 68,
  ViolateReason = 96,
  SuspendReason = 97,
}

export enum ObjectTypes {
  CreateRequest = 50,
  EditRequest = 51,
  Franchise = 52,
  CancelFranchise = 53,
  ViolateFranchise = 94,
  SuspendFranchise = 95,
}

export enum FranchiseStatus {
  Approved = 21,
  Canceled = 22,
  Expired = 23,
  Suspended = 24,
  Violated = 25,
  All = 26,
}

export enum FranchiseTypes {
  Main = 40,
  Normal = 41,
}

export enum FranchiseStatuses {
  WaitingForPayment = 15,
  Approved = 16,
  Canceled = 17,
}

export enum RequestStatusStatusEnum {
  New = 10,
  WaitingForPayment = 11,
  Paid = 12,
  WaitingForCancel = 13,
  Canceled = 14,
  CanceleRejected = 15,
}

export enum PaymentMethod {
  CreditCard = 80,
  Sadad = 81,
}

export enum CrTypes {
  Internal = 30,
  External = 31,
}

export enum ReferenceTypes {
  CrName = 92,
  Trademark = 93,
}
export enum ActiveStatus {
  Active = 1,
  InActive = 2,
}
